<template>
  <div class="page-integrations">
    <landing-header />

    <main>
      <section class="hero-integrations">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-ecosysteme">Écosystème Ouvert</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Termoflow s'adapte <br />
              <span class="gradient-text">à vos outils</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Ne changez pas vos habitudes. Termoflow se connecte à vos logiciels existants pour structurer votre terrain sans bouleverser votre comptabilité ou vos processus actuels.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="integration-visual shadow-2xl">
              <div class="hub-circle">Termoflow</div>
              <div class="orbit-item tool-1">Facturation</div>
              <div class="orbit-item tool-2">Comptabilité</div>
              <div class="orbit-item tool-3">CRM</div>
              <div class="connector-lines"></div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white border-y border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="text-center max-w-3xl mx-auto mb-20">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">Une séparation claire pour plus d'efficacité</h2>
            <p class="text-gray-600">Nous croyons aux outils spécialisés. Termoflow gère le cœur de votre métier, vos logiciels actuels gèrent le reste.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div class="role-card field">
              <div class="role-head">Chez Termoflow</div>
              <ul class="role-list">
                <li><i class="fa-solid fa-check"></i> Suivi des interventions</li>
                <li><i class="fa-solid fa-check"></i> Réglementation & CERFA</li>
                <li><i class="fa-solid fa-check"></i> Gestion des fluides & stocks</li>
                <li><i class="fa-solid fa-check"></i> Portail client opérationnel</li>
              </ul>
            </div>
            <div class="role-card billing">
              <div class="role-head">Dans vos outils actuels</div>
              <ul class="role-list">
                <li><i class="fa-solid fa-check"></i> Facturation & Devis</li>
                <li><i class="fa-solid fa-check"></i> Comptabilité générale</li>
                <li><i class="fa-solid fa-check"></i> Gestion sociale / RH</li>
                <li><i class="fa-solid fa-check"></i> Analyse financière</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-20">
          <div class="lg:w-1/2">
            <h2 class="text-3xl font-bold text-gray-900 mb-6">Finies les doubles saisies</h2>
            <p class="text-gray-600 mb-8 text-lg">Grâce à nos exports structurés et nos passerelles, les données collectées sur le terrain par vos techniciens alimentent directement vos processus administratifs.</p>
            
            <div class="sync-feature">
              <div class="s-icon"><i class="fa-solid fa-bolt"></i></div>
              <div>
                <h4 class="font-bold">Transmission fluide</h4>
                <p class="text-sm text-gray-500">Les données d'intervention sont prêtes à être transformées en factures.</p>
              </div>
            </div>
            <div class="sync-feature">
              <div class="s-icon"><i class="fa-solid fa-plug"></i></div>
              <div>
                <h4 class="font-bold">Connexion à vos outils existants</h4>
                <p class="text-sm text-gray-500"> Termoflow se connecte à votre logiciel de facturation et à vos outils métiers pour assurer une continuité entre le terrain et l’administratif. </p>
              </div>
            </div>
          </div>
          <div class="lg:w-1/2">
             <div class="data-flow-box">
                <div class="flow-step-mini">Terrain</div>
                <div class="flow-arrow"><i class="fa-solid fa-arrow-right"></i></div>
                <div class="flow-step-mini highlight">Termoflow</div>
                <div class="flow-arrow"><i class="fa-solid fa-arrow-right"></i></div>
                <div class="flow-step-mini">Facturation</div>
             </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            <div v-for="b in ['Adoption facile', 'Zéro friction', 'Données cohérentes', 'Évolutivité', 'Gain de temps']" :key="b" class="benefit-tag">
              {{ b }}
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center rounded-[3rem] mx-4 mb-10">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black mb-8">Un outil qui s'intègre à votre succès</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'IntegrationsPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-integrations {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #f0f9ff, transparent 40%);
}

.badge-ecosysteme {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #f0fdf4;
  color: #16a34a;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- VISUAL INTEGRATION --- */
.integration-visual {
  height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hub-circle {
  width: 120px;
  height: 120px;
  background: #f97316;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  z-index: 10;
  box-shadow: 0 0 40px rgba(249, 115, 22, 0.3);
}
.orbit-item {
  position: absolute;
  padding: 0.8rem 1.2rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 9999px;
  font-weight: 800;
  font-size: 0.8rem;
  color: #4b5563;
}
.tool-1 { top: 20%; right: 10%; }
.tool-2 { bottom: 20%; left: 10%; }
.tool-3 { top: 30%; left: 15%; }

/* --- ROLE CARDS --- */
.role-card { padding: 3rem; border-radius: 2rem; border: 1px solid #e5e7eb; }
.role-card.field { background: #f8fafc; border-bottom: 6px solid #f97316; }
.role-card.billing { background: white; border-bottom: 6px solid #cbd5e1; }
.role-head { font-weight: 900; font-size: 1.25rem; margin-bottom: 2rem; color: #1f2937; }
.role-list { list-style: none; padding: 0; }
.role-list li { display: flex; align-items: center; gap: 1rem; font-weight: 700; color: #4b5563; margin-bottom: 1rem; }
.role-list li i { color: #f97316; }

/* --- SYNC FEATURE --- */
.sync-feature { display: flex; gap: 1.5rem; margin-bottom: 2rem; }
.s-icon { width: 3rem; height: 3rem; background: #eff6ff; color: #3b82f6; border-radius: 0.75rem; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; flex-shrink: 0; }

.data-flow-box {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: white;
  padding: 3rem 2rem;
  border-radius: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05);
}
.flow-step-mini { padding: 0.75rem 1.25rem; background: #f3f4f6; border-radius: 0.75rem; font-weight: 800; font-size: 0.8rem; color: #6b7280; }
.flow-step-mini.highlight { background: #f97316; color: white; }
.flow-arrow { color: #d1d5db; }

/* --- BENEFITS --- */
.benefit-tag {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 1rem;
  text-align: center;
  font-weight: 800;
  color: #1f2937;
  font-size: 0.9rem;
  border: 1px solid #f3f4f6;
}

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-white { background: white; color: #f97316; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }
.btn-outline-large-white { border: 2px solid rgba(255,255,255,0.3); padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: white; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-integrations { text-align: center; padding-top: 8rem; }
  .hero-integrations .flex { flex-direction: column; }
  .integration-visual { margin-top: 4rem; height: 300px; }
}
</style>